import { pricingGroups, analysisApps } from './pricing'
import type { PricingApp } from './pricing'

// Desktop installers live on our own nginx under /downloads/<app id>/, outside dist/ (see nginx/prod.conf).
// Each folder holds the versioned installers plus latest.json, which the app's release step uploads last.
const DOWNLOADS_BASE_PATH: string = '/downloads'
const MANIFEST_FILE_NAME: string = 'latest.json'
const DOWNLOAD_PAGE_BASE_PATH: string = '/download'

export function downloadPagePath(appId: string): string {
  return `${DOWNLOAD_PAGE_BASE_PATH}/${appId}`
}

export function releaseManifestUrl(appId: string): string {
  return `${DOWNLOADS_BASE_PATH}/${appId}/${MANIFEST_FILE_NAME}`
}

export function installerUrl(appId: string, fileName: string): string {
  return `${DOWNLOADS_BASE_PATH}/${appId}/${fileName}`
}

/** Every app sold as a Windows installer; each gets its own download page. */
export const downloadableApps: readonly PricingApp[] = [...pricingGroups.flatMap((g) => g.members), ...analysisApps].filter((a) => a.launch?.kind === 'download')
